import { ManagerRole } from '../permissions/PermissionResolver';

// Roles the business-managers endpoints let other team members edit or delete.
const EDITABLE_ROLES = [ManagerRole.StoreEmployee, ManagerRole.StoreOperator];

/**
 * Roles offered by Team → Managers' "Add manager" form. Owner (StoreAdmin) is
 * only offered to PLG partner staff, mirroring the backend's canProvisionOwner().
 */
export function getAssignableRoles({ canProvisionOwner = false } = {}) {
  return [...EDITABLE_ROLES, ...(canProvisionOwner ? [ManagerRole.StoreAdmin] : [])];
}

export function isOwnerRole(role) {
  return role === ManagerRole.StoreAdmin;
}

/**
 * POST /business-managers payload for the "Add manager" form. An owner is the
 * same call as the onboarding wizard's invite: StoreAdmin, one restaurant, as_owner.
 */
export function buildCreateManagerPayload({ role, companies = [], ...rest }) {
  if (isOwnerRole(role)) {
    return { ...rest, roles: [ManagerRole.StoreAdmin], companies: companies.slice(0, 1), as_owner: true };
  }

  return { ...rest, roles: [role], companies };
}

/**
 * Whether a manager row is read-only in Team → Managers: the restaurant owner,
 * or anyone without an Employee/Operator role (the backend refuses both).
 */
export function isProtectedManager(manager) {
  if (manager?.is_owner) {
    return true;
  }

  return !(manager?.roles ?? []).some((role) => EDITABLE_ROLES.includes(role));
}
